import React, {Component} from 'react';

class NotFoundComponent extends Component {
    render(){
        return(
            <div>Pagina no encontrada</div>
        );
    }
}
export default NotFoundComponent;